import { request } from "../_helpers/Auth";

const namespace = "/api/company";

export const getCompany = () => {
    return request({
        url: namespace,
        method: "get",
    });
};

export const getEstablishments = () => {
    return request({
        url: namespace + "/establishments",
        method: "get",
    });
};

export const getGroupsBySubdomain = (sub_domain) => {
    return request({
        url: namespace + "/groups/" + sub_domain,
        method: "get",
    });
};

export const putCompany = (payload) => {
    return request({
        url: namespace,
        method: "post",
        data: payload,
    });
};

/** @param {string} code */
export const getCompanySetting = (code) => {
    return request({
        url: `${namespace}/setting/${encodeURIComponent(code)}`,
        method: "get",
    });
};

/** @param {{ code: string, value: unknown }} payload */
export const upsertCompanySetting = (payload) => {
    return request({
        url: `${namespace}/setting`,
        method: "post",
        data: payload,
    });
};

export const COMPANY_SETTING_CODE_FALLBACK_WORK_HOUR_TYPE_ID =
    "planning.fallback_work_hour_type_id";
